module.exports = __webpack_public_path__ + "img/20200801_130633.185d8a02.jpg";